
import React, {useState} from 'react';
import styles from  './Wallets.module.css';
import TextBaloon from '../components/TextBaloon'; 
// import BecomePremiumInvite from '../components/BecomePremiumInvite'; 

function Wallets() { 
    
    const HoverableLink = ({ href, children }) => {
        const [hover, setHover] = useState(false);
      
        const linkStyle = {
          textDecoration: 'none',
          color: hover ? 'orange' : 'inherit', // Change the color on hover
          fontSize: '15pt',
          display:'contents'
        };
      
        return (
          <a
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
          >
            {children}
          </a>
        );
    };

    return (
        <div className={styles.main_page}>
            <header className={styles.main_header}>
                <h1>Recommended wallets</h1>
            </header>            
            <main>
                <section className={styles.content} style={{display:'flex', flexDirection:'column', alignItems:'center'}}>                    
                    <TextBaloon number="" textColor='#d2d2d2' text={<>Here are some trusted and recommended wallets you can install, but you’re not limited to these. Just be sure to choose a wallet that’s reliable and secure</>} color={'#50a13e'} />
                    <br/>
                    <div style={{ display: 'table', width: '500px', border:'1px solid gray', borderRadius:'10px' }}>
                        {/* Table Header */}
                        <div style={{ display: 'table-row', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#f0f0f030' }}>
                            <div style={{ display: 'table-cell', padding: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="Ethereum" style={{ width: '45px', marginRight: '8px' }} />
                                <span style={{fontSize:'18pt', color:'aliceblue'}}>Ethereum</span>
                            </div>
                            </div>
                            <div style={{ display: 'table-cell', padding: '10px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png" alt="Solana" style={{ width: '45px', marginRight: '8px' }} />
                                <span style={{fontSize:'18pt', color:'aliceblue'}}>Solana</span>
                            </div>
                            </div>
                        </div>

                        {/* Table Content */}
                        <div style={{ display: 'table-row', textAlign: 'center' }}>
                            <div style={{ display: 'table-cell', padding: '10px', paddingLeft:'80px', width:'150px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>                                                                
                                <HoverableLink href="https://metamask.io/download/">
                                    <img src={require('../images/metamask.png')} alt="MetaMask" style={{ width: '35px', marginRight: '8px' }} />
                                    MetaMask
                                </HoverableLink>
                            </div>
                            </div>
                            <div style={{ display: 'table-cell', padding: '10px', paddingLeft:'80px', width:'150px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>                                                                
                                <HoverableLink href="https://phantom.app/download">
                                    <img src={require('../images/phantom.png')} alt="Phantom" style={{ width: '35px', marginRight: '8px' }} />
                                    Phantom
                                </HoverableLink>
                            </div>
                            </div>
                        </div>
                        <div style={{ display: 'table-row', textAlign: 'center' }}>
                            <div style={{ display: 'table-cell', padding: '10px', paddingLeft:'80px', width:'150px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>                                                                
                                <HoverableLink href="https://trustwallet.com/download">
                                    <img src={require('../images/trust.png')} alt="Trust Wallet" style={{ width: '35px', marginRight: '8px' }} />
                                    Trust Wallet
                                </HoverableLink>
                            </div>
                            </div>
                            <div style={{ display: 'table-cell', padding: '10px', paddingLeft:'80px', width:'150px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>                                                                
                                <HoverableLink href="https://solflare.com/download">
                                    <img src={require('../images/solflaire.png')} alt="Solflare" style={{ width: '35px', marginRight: '8px' }} />
                                    Solflare
                                </HoverableLink>
                            </div>
                            </div>
                        </div>
                        <div style={{ display: 'table-row', textAlign: 'center' }}>
                            <div style={{ display: 'table-cell', padding: '10px', paddingLeft:'80px', width:'150px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>                                
                                <HoverableLink href="https://www.coinbase.com/wallet/downloads">
                                    <img src={require('../images/coinbase.png')} alt="Coinbase" style={{ width: '35px', marginRight: '8px' }} />
                                    Coinbase
                                </HoverableLink>
                            </div>
                            </div>
                            <div style={{ display: 'table-cell', padding: '10px', paddingLeft:'80px', width:'150px' }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'left' }}>                                
                                <HoverableLink href="https://www.exodus.com/download/">
                                    <img src={require('../images/Exodus.png')} alt="Exodus" style={{ width: '35px', marginRight: '8px' }} />
                                    Exodus
                                </HoverableLink>
                            </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>                     
        </div>
    );
}

export default Wallets;



  






